// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  instanceId: __t.u64().name("instance_id"),
  heroId: __t.u64().name("hero_id"),
  drawIndex: __t.u8().name("draw_index"),
  table: __t.string(),
  values: __t.array(__t.u32()),
  itemId: __t.u64().name("item_id"),
  redrawn: __t.bool(),
  bumped: __t.bool(),
});
